import { Layout as AntdLayout } from 'antd';
import AppRoutes from '../../routing/AppRoutes';


const { Content } = AntdLayout;

const MainContent = () => {

	return (
		<Content style={{
				overflow: 'initial', minWidth:'350px', fontSize:'16px'											
			}}>
			<AppRoutes />		
		</Content>
	)
};

export default MainContent;